(function () {
  var CLOUD_NAME = 'nmfqqvl5';
  var UPLOAD_PRESET = 'pes_custom_orders';
  var UPLOAD_URL = 'https://api.cloudinary.com/v1_1/' + CLOUD_NAME + '/image/upload';

  var FONT_SIZE_PRESETS = { small: 24, medium: 36, large: 48, xl: 64 };
  var IMAGE_SIZE_PRESETS = { small: 15, medium: 25, large: 35, xl: 50 };
  var POSITIONS = {
    'top-left': [0, 0], 'top-center': [50, 0], 'top-right': [100, 0],
    'mid-left': [0, 50], center: [50, 50], 'mid-right': [100, 50],
    'bottom-left': [0, 100], 'bottom-center': [50, 100], 'bottom-right': [100, 100]
  };

  function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }

  var measureCanvas = null;
  function measureCharWidths(text, font) {
    if (!measureCanvas) measureCanvas = document.createElement('canvas');
    var ctx = measureCanvas.getContext('2d');
    ctx.font = font;
    var widths = [];
    for (var i = 0; i < text.length; i++) widths.push(ctx.measureText(text[i]).width);
    return widths;
  }

  // Returns null for straight text (curve ~ 0), otherwise an array of
  // { ch, x, y, angleDeg } offsets (in the same px unit as fontSize) relative to the text's center.
  function computeArcLayout(text, fontSizePx, fontFamily, curve) {
    if (!text) return null;
    var curveFactor = clamp(curve, -100, 100) / 100;
    if (Math.abs(curveFactor) < 0.02) return null;

    var font = fontSizePx + 'px "' + fontFamily + '"';
    var widths = measureCharWidths(text, font);
    var totalWidth = widths.reduce(function (a, b) { return a + b; }, 0);
    if (totalWidth <= 0) return null;

    var absFactor = Math.abs(curveFactor);
    var R = Math.max(totalWidth * 0.35, (totalWidth * 0.9) / absFactor);
    var totalAngle = totalWidth / R;
    var sign = curveFactor >= 0 ? 1 : -1;

    var cum = 0;
    var layout = [];
    for (var i = 0; i < text.length; i++) {
      var w = widths[i];
      var centerOffset = cum + w / 2;
      cum += w;
      var theta = (centerOffset / totalWidth) * totalAngle - totalAngle / 2;
      var x = R * Math.sin(theta);
      var y = sign * R * (1 - Math.cos(theta));
      layout.push({ ch: text[i], x: x, y: y, angleDeg: (sign * theta * 180) / Math.PI });
    }
    return layout;
  }

  function uploadToCloudinary(fileOrDataUrl) {
    var formData = new FormData();
    formData.append('file', fileOrDataUrl);
    formData.append('upload_preset', UPLOAD_PRESET);
    return fetch(UPLOAD_URL, { method: 'POST', body: formData })
      .then(function (response) {
        if (!response.ok) throw new Error('Cloudinary upload failed');
        return response.json();
      })
      .then(function (data) {
        return data.secure_url;
      });
  }

  function setHiddenInput(form, name, value) {
    var input = form.querySelector('input[data-pes-dynamic="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.setAttribute('data-pes-dynamic', name);
      form.appendChild(input);
    }
    input.value = value;
  }

  function findMediaContainer() {
    var active = document.querySelector('.product__media-item.is-active') || document.querySelector('.product__media-item');
    return active;
  }

  function initPersonalizer(root) {
    var textInput = root.querySelector('[data-pes-text]');
    var textCounter = root.querySelector('[data-pes-text-counter]');
    var fontSelect = root.querySelector('[data-pes-font]');
    var sizeSlider = root.querySelector('[data-pes-size-slider]');
    var sizeValue = root.querySelector('[data-pes-size-value]');
    var sizePresetButtons = root.querySelectorAll('[data-pes-size-preset]');
    var positionButtons = root.querySelectorAll('[data-pes-position]');
    var hSlider = root.querySelector('[data-pes-h-slider]');
    var vSlider = root.querySelector('[data-pes-v-slider]');
    var rotationSlider = root.querySelector('[data-pes-rotation-slider]');
    var rotationValue = root.querySelector('[data-pes-rotation-value]');
    var rotationPresetButtons = root.querySelectorAll('[data-pes-rotation-preset]');
    var curveSlider = root.querySelector('[data-pes-curve-slider]');
    var curveValue = root.querySelector('[data-pes-curve-value]');
    var imageInput = root.querySelector('[data-pes-image-input]');
    var uploadZone = root.querySelector('[data-pes-upload-zone]');
    var uploadStatus = root.querySelector('[data-pes-upload-status]');
    var imageHSlider = root.querySelector('[data-pes-image-h-slider]');
    var imageVSlider = root.querySelector('[data-pes-image-v-slider]');
    var imageSizeSlider = root.querySelector('[data-pes-image-size-slider]');
    var imageSizeValue = root.querySelector('[data-pes-image-size-value]');
    var imageSizePresetButtons = root.querySelectorAll('[data-pes-image-size-preset]');
    var styleButtons = root.querySelectorAll('[data-pes-style]');
    var resetButton = root.querySelector('[data-pes-reset]');

    var form =
      root.closest('form') ||
      (root.closest('product-form') && root.closest('product-form').querySelector('form')) ||
      document.querySelector('product-form form') ||
      document.querySelector('form[action*="/cart/add"]:not(.installment)');

    var mediaContainer = findMediaContainer();
    var overlay = null;
    var placeholder = null;
    var textEl = null;
    var imageEl = null;

    var state = {
      text: '',
      font: fontSelect ? fontSelect.value : 'Montserrat',
      fontSize: 48,
      textPosX: 50,
      textPosY: 50,
      rotation: 0,
      curve: 0,
      imageUrl: null,
      imagePosX: 50,
      imagePosY: 50,
      imageSizePct: 25,
      engraveStyle: 'dark'
    };

    if (mediaContainer) {
      var computed = getComputedStyle(mediaContainer);
      if (computed.position === 'static') mediaContainer.style.position = 'relative';
      overlay = document.createElement('div');
      overlay.className = 'pes-preview-overlay pes-style-dark';
      placeholder = document.createElement('div');
      placeholder.className = 'pes-preview-placeholder';
      placeholder.textContent = 'Type engraving text to preview';
      textEl = document.createElement('div');
      textEl.className = 'pes-preview-text';
      imageEl = document.createElement('img');
      imageEl.className = 'pes-preview-image';
      imageEl.hidden = true;
      overlay.appendChild(placeholder);
      overlay.appendChild(textEl);
      overlay.appendChild(imageEl);
      mediaContainer.appendChild(overlay);
    }

    function renderTextContent() {
      var arcLayout = computeArcLayout(state.text, state.fontSize, state.font, state.curve);
      textEl.innerHTML = '';
      textEl.style.fontFamily = '"' + state.font + '"';
      textEl.style.fontSize = state.fontSize + 'px';

      if (!arcLayout) {
        textEl.textContent = state.text;
        return;
      }

      arcLayout.forEach(function (charInfo) {
        var span = document.createElement('span');
        span.className = 'pes-preview-char';
        span.textContent = charInfo.ch;
        span.style.transform =
          'translate(calc(-50% + ' + charInfo.x + 'px), calc(-50% + ' + charInfo.y + 'px)) rotate(' + charInfo.angleDeg + 'deg)';
        textEl.appendChild(span);
      });
    }

    function renderPreview() {
      if (!overlay) return;
      var hasText = state.text.trim().length > 0;
      var hasImage = !!state.imageUrl;

      placeholder.hidden = hasText || hasImage;

      renderTextContent();
      textEl.style.left = state.textPosX + '%';
      textEl.style.top = state.textPosY + '%';
      textEl.style.transform = 'translate(-50%, -50%) rotate(' + state.rotation + 'deg)';
      textEl.hidden = !hasText;

      if (hasImage) {
        imageEl.src = state.imageUrl;
        imageEl.style.left = state.imagePosX + '%';
        imageEl.style.top = state.imagePosY + '%';
        imageEl.style.width = state.imageSizePct + '%';
        imageEl.style.height = 'auto';
        imageEl.hidden = false;
      } else {
        imageEl.hidden = true;
      }

      overlay.classList.toggle('pes-style-dark', state.engraveStyle === 'dark');
      overlay.classList.toggle('pes-style-light', state.engraveStyle === 'light');
    }

    function setActivePreset(buttons, matchFn) {
      buttons.forEach(function (btn) {
        btn.classList.toggle('is-active', matchFn(btn));
      });
    }

    function clearPositionPresetActive() {
      positionButtons.forEach(function (b) { b.classList.remove('is-active'); });
    }

    // --- Direct drag-to-move on the live preview overlay ---
    function makeDraggable(el, setPos, onMove) {
      var dragging = false;

      el.addEventListener('pointerdown', function (e) {
        dragging = true;
        el.classList.add('is-dragging');
        el.setPointerCapture(e.pointerId);
        e.preventDefault();
      });

      el.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var rect = overlay.getBoundingClientRect();
        var x = clamp(((e.clientX - rect.left) / rect.width) * 100, 0, 100);
        var y = clamp(((e.clientY - rect.top) / rect.height) * 100, 0, 100);
        setPos(x, y);
        clearPositionPresetActive();
        onMove(x, y);
        renderPreview();
      });

      function endDrag() {
        if (!dragging) return;
        dragging = false;
        el.classList.remove('is-dragging');
      }

      el.addEventListener('pointerup', endDrag);
      el.addEventListener('pointercancel', endDrag);
    }

    makeDraggable(
      textEl,
      function (x, y) { state.textPosX = x; state.textPosY = y; },
      function (x, y) {
        if (hSlider) hSlider.value = x;
        if (vSlider) vSlider.value = y;
      }
    );

    makeDraggable(
      imageEl,
      function (x, y) { state.imagePosX = x; state.imagePosY = y; },
      function (x, y) {
        if (imageHSlider) imageHSlider.value = x;
        if (imageVSlider) imageVSlider.value = y;
      }
    );

    if (textInput) {
      textInput.addEventListener('input', function () {
        state.text = textInput.value.slice(0, 50);
        if (textCounter) textCounter.textContent = state.text.length + '/50';
        document.fonts.load(state.fontSize + 'px "' + state.font + '"').catch(function () {}).then(renderPreview);
      });
    }

    if (fontSelect) {
      fontSelect.addEventListener('change', function () {
        state.font = fontSelect.value;
        document.fonts.load(state.fontSize + 'px "' + state.font + '"').catch(function () {}).then(renderPreview);
      });
    }

    if (sizeSlider) {
      sizeSlider.addEventListener('input', function () {
        state.fontSize = parseInt(sizeSlider.value, 10);
        if (sizeValue) sizeValue.textContent = state.fontSize + 'px';
        setActivePreset(sizePresetButtons, function (btn) {
          return FONT_SIZE_PRESETS[btn.getAttribute('data-pes-size-preset')] === state.fontSize;
        });
        renderPreview();
      });
    }

    sizePresetButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-pes-size-preset');
        state.fontSize = FONT_SIZE_PRESETS[key];
        if (sizeSlider) sizeSlider.value = state.fontSize;
        if (sizeValue) sizeValue.textContent = state.fontSize + 'px';
        setActivePreset(sizePresetButtons, function (b) { return b === btn; });
        renderPreview();
      });
    });

    if (imageSizeSlider) {
      imageSizeSlider.addEventListener('input', function () {
        state.imageSizePct = parseInt(imageSizeSlider.value, 10);
        if (imageSizeValue) imageSizeValue.textContent = state.imageSizePct + '%';
        setActivePreset(imageSizePresetButtons, function (btn) {
          return IMAGE_SIZE_PRESETS[btn.getAttribute('data-pes-image-size-preset')] === state.imageSizePct;
        });
        renderPreview();
      });
    }

    imageSizePresetButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-pes-image-size-preset');
        state.imageSizePct = IMAGE_SIZE_PRESETS[key];
        if (imageSizeSlider) imageSizeSlider.value = state.imageSizePct;
        if (imageSizeValue) imageSizeValue.textContent = state.imageSizePct + '%';
        setActivePreset(imageSizePresetButtons, function (b) { return b === btn; });
        renderPreview();
      });
    });

    positionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-pes-position');
        var coords = POSITIONS[key];
        state.textPosX = coords[0];
        state.textPosY = coords[1];
        if (hSlider) hSlider.value = state.textPosX;
        if (vSlider) vSlider.value = state.textPosY;
        setActivePreset(positionButtons, function (b) { return b === btn; });
        renderPreview();
      });
    });

    if (hSlider) {
      hSlider.addEventListener('input', function () {
        state.textPosX = parseInt(hSlider.value, 10);
        clearPositionPresetActive();
        renderPreview();
      });
    }

    if (vSlider) {
      vSlider.addEventListener('input', function () {
        state.textPosY = parseInt(vSlider.value, 10);
        clearPositionPresetActive();
        renderPreview();
      });
    }

    if (imageHSlider) {
      imageHSlider.addEventListener('input', function () {
        state.imagePosX = parseInt(imageHSlider.value, 10);
        renderPreview();
      });
    }

    if (imageVSlider) {
      imageVSlider.addEventListener('input', function () {
        state.imagePosY = parseInt(imageVSlider.value, 10);
        renderPreview();
      });
    }

    if (rotationSlider) {
      rotationSlider.addEventListener('input', function () {
        state.rotation = parseInt(rotationSlider.value, 10);
        if (rotationValue) rotationValue.textContent = state.rotation + '°';
        setActivePreset(rotationPresetButtons, function (btn) {
          return parseInt(btn.getAttribute('data-pes-rotation-preset'), 10) === state.rotation;
        });
        renderPreview();
      });
    }

    rotationPresetButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.rotation = parseInt(btn.getAttribute('data-pes-rotation-preset'), 10);
        if (rotationSlider) rotationSlider.value = state.rotation;
        if (rotationValue) rotationValue.textContent = state.rotation + '°';
        setActivePreset(rotationPresetButtons, function (b) { return b === btn; });
        renderPreview();
      });
    });

    if (curveSlider) {
      curveSlider.addEventListener('input', function () {
        state.curve = parseInt(curveSlider.value, 10);
        if (curveValue) curveValue.textContent = state.curve;
        renderPreview();
      });
    }

    styleButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.engraveStyle = btn.getAttribute('data-pes-style');
        setActivePreset(styleButtons, function (b) { return b === btn; });
        renderPreview();
      });
    });

    function handleImageFile(file) {
      if (!file) return;
      if (uploadStatus) {
        uploadStatus.hidden = false;
        uploadStatus.textContent = 'Uploading…';
      }
      if (uploadZone) uploadZone.classList.add('is-uploading');
      uploadToCloudinary(file)
        .then(function (url) {
          state.imageUrl = url;
          if (uploadStatus) uploadStatus.textContent = 'Image added ✓ — drag it on the photo to reposition';
          renderPreview();
        })
        .catch(function () {
          if (uploadStatus) uploadStatus.textContent = 'Upload failed. Please try again.';
        })
        .finally(function () {
          if (uploadZone) uploadZone.classList.remove('is-uploading');
        });
    }

    if (imageInput) {
      imageInput.addEventListener('change', function () {
        var file = imageInput.files && imageInput.files[0];
        handleImageFile(file);
      });
    }

    if (uploadZone) {
      ['dragenter', 'dragover'].forEach(function (evt) {
        uploadZone.addEventListener(evt, function (e) {
          e.preventDefault();
          e.stopPropagation();
          uploadZone.classList.add('is-dragover');
        });
      });
      ['dragleave', 'dragend'].forEach(function (evt) {
        uploadZone.addEventListener(evt, function (e) {
          e.preventDefault();
          e.stopPropagation();
          uploadZone.classList.remove('is-dragover');
        });
      });
      uploadZone.addEventListener('drop', function (e) {
        e.preventDefault();
        e.stopPropagation();
        uploadZone.classList.remove('is-dragover');
        var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        handleImageFile(file);
      });
    }

    if (resetButton) {
      resetButton.addEventListener('click', function () {
        state = {
          text: '', font: fontSelect ? fontSelect.options[0].value : 'Montserrat', fontSize: 48,
          textPosX: 50, textPosY: 50, rotation: 0, curve: 0,
          imageUrl: null, imagePosX: 50, imagePosY: 50, imageSizePct: 25,
          engraveStyle: 'dark'
        };
        if (textInput) textInput.value = '';
        if (textCounter) textCounter.textContent = '0/50';
        if (fontSelect) fontSelect.selectedIndex = 0;
        if (sizeSlider) sizeSlider.value = state.fontSize;
        if (sizeValue) sizeValue.textContent = state.fontSize + 'px';
        if (hSlider) hSlider.value = state.textPosX;
        if (vSlider) vSlider.value = state.textPosY;
        if (imageHSlider) imageHSlider.value = state.imagePosX;
        if (imageVSlider) imageVSlider.value = state.imagePosY;
        if (imageSizeSlider) imageSizeSlider.value = state.imageSizePct;
        if (imageSizeValue) imageSizeValue.textContent = state.imageSizePct + '%';
        if (rotationSlider) rotationSlider.value = state.rotation;
        if (rotationValue) rotationValue.textContent = '0°';
        if (curveSlider) curveSlider.value = 0;
        if (curveValue) curveValue.textContent = '0';
        clearPositionPresetActive();
        setActivePreset(positionButtons, function (btn) { return btn.getAttribute('data-pes-position') === 'center'; });
        setActivePreset(sizePresetButtons, function (btn) { return FONT_SIZE_PRESETS[btn.getAttribute('data-pes-size-preset')] === state.fontSize; });
        setActivePreset(imageSizePresetButtons, function (btn) { return IMAGE_SIZE_PRESETS[btn.getAttribute('data-pes-image-size-preset')] === state.imageSizePct; });
        setActivePreset(rotationPresetButtons, function (btn) { return parseInt(btn.getAttribute('data-pes-rotation-preset'), 10) === 0; });
        setActivePreset(styleButtons, function (btn) { return btn.getAttribute('data-pes-style') === 'dark'; });
        if (uploadStatus) { uploadStatus.hidden = true; uploadStatus.textContent = ''; }
        renderPreview();
      });
    }

    renderPreview();

    function buildProofCanvas() {
      return new Promise(function (resolve, reject) {
        var baseImg = mediaContainer ? mediaContainer.querySelector('img') : null;
        if (!baseImg) {
          reject(new Error('No product image found'));
          return;
        }
        var proofImg = new Image();
        proofImg.crossOrigin = 'anonymous';
        proofImg.onload = function () {
          var canvas = document.createElement('canvas');
          var w = proofImg.naturalWidth || 800;
          var h = proofImg.naturalHeight || 800;
          canvas.width = w;
          canvas.height = h;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(proofImg, 0, 0, w, h);

          function drawTextAndFinish(uploadedImg) {
            if (uploadedImg) {
              var iw = w * (state.imageSizePct / 100);
              var ih = iw * (uploadedImg.naturalHeight / uploadedImg.naturalWidth);
              var ix = (state.imagePosX / 100) * w;
              var iy = (state.imagePosY / 100) * h;
              ctx.save();
              ctx.filter = state.engraveStyle === 'dark'
                ? 'grayscale(1) brightness(0.5) contrast(1.3)'
                : 'grayscale(1) brightness(1.8) contrast(0.85)';
              ctx.globalAlpha = 0.85;
              ctx.globalCompositeOperation = state.engraveStyle === 'dark' ? 'multiply' : 'screen';
              ctx.drawImage(uploadedImg, ix - iw / 2, iy - ih / 2, iw, ih);
              ctx.restore();
            }

            if (state.text.trim().length > 0) {
              var scaleFactor = w / (mediaContainer.getBoundingClientRect().width || w);
              var tx = (state.textPosX / 100) * w;
              var ty = (state.textPosY / 100) * h;
              var canvasFontSize = Math.round(state.fontSize * scaleFactor);
              var fillColor = state.engraveStyle === 'dark' ? 'rgba(36,22,8,0.85)' : 'rgba(255,255,255,0.9)';

              ctx.save();
              ctx.translate(tx, ty);
              ctx.rotate((state.rotation * Math.PI) / 180);

              var arcLayout = computeArcLayout(state.text, canvasFontSize, state.font, state.curve);
              ctx.font = canvasFontSize + 'px "' + state.font + '"';
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.fillStyle = fillColor;

              if (arcLayout) {
                arcLayout.forEach(function (charInfo) {
                  ctx.save();
                  ctx.translate(charInfo.x, charInfo.y);
                  ctx.rotate((charInfo.angleDeg * Math.PI) / 180);
                  ctx.fillText(charInfo.ch, 0, 0);
                  ctx.restore();
                });
              } else {
                ctx.fillText(state.text, 0, 0);
              }
              ctx.restore();
            }

            resolve(canvas.toDataURL('image/png'));
          }

          if (state.imageUrl) {
            var uploadedImg = new Image();
            uploadedImg.crossOrigin = 'anonymous';
            uploadedImg.onload = function () { drawTextAndFinish(uploadedImg); };
            uploadedImg.onerror = function () { drawTextAndFinish(null); };
            uploadedImg.src = state.imageUrl;
          } else {
            drawTextAndFinish(null);
          }
        };
        proofImg.onerror = reject;
        proofImg.src = baseImg.currentSrc || baseImg.src;
      });
    }

    var submitting = false;
    form.addEventListener(
      'submit',
      function (event) {
        if (submitting) {
          submitting = false;
          return;
        }

        var hasText = state.text.trim().length > 0;
        var hasImage = !!state.imageUrl;

        if (!hasText && !hasImage) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        buildProofCanvas()
          .then(function (proofDataUrl) {
            return uploadToCloudinary(proofDataUrl);
          })
          .then(function (proofUrl) {
            setHiddenInput(form, 'properties[Custom Design Proof]', proofUrl);
            if (hasText) {
              setHiddenInput(form, 'properties[Engraving Text]', state.text);
              setHiddenInput(form, 'properties[Font]', state.font);
            }
            setHiddenInput(form, 'properties[Engraving Style]', state.engraveStyle === 'dark' ? 'Dark Etched' : 'Light Frosted');
            submitting = true;
            if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
          })
          .catch(function () {
            submitting = true;
            if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
          });
      },
      true
    );
  }

  function init() {
    var roots = document.querySelectorAll('[data-pes-root]');
    roots.forEach(initPersonalizer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
